import { Pagination, Form } from 'react-bootstrap';
import { PAGE_SIZE_OPTIONS } from '../../../lib/wallet/constants';

const DataTablePagination = ({ page, totalPages, pageSize, totalCount, onPageChange, onPageSizeChange }) => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);
    if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
    }
    for (let i = start; i <= end; i++) {
        pages.push(i);
    }

    return (
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mt-3">
            <div className="d-flex align-items-center gap-2">
                <span className="text-muted small">
                    Showing {Math.min((page - 1) * pageSize + 1, totalCount)}–{Math.min(page * pageSize, totalCount)} of {totalCount}
                </span>
                <Form.Select
                    size="sm"
                    value={pageSize}
                    onChange={(e) => onPageSizeChange(Number(e.target.value))}
                    className="w-auto"
                >
                    {PAGE_SIZE_OPTIONS.map((s) => (
                        <option key={s} value={s}>
                            {s} / page
                        </option>
                    ))}
                </Form.Select>
            </div>

            <Pagination className="mb-0" size="sm">
                <Pagination.First onClick={() => onPageChange(1)} disabled={page <= 1} />
                <Pagination.Prev onClick={() => onPageChange(page - 1)} disabled={page <= 1} />
                {start > 1 && <Pagination.Ellipsis disabled />}
                {pages.map((p) => (
                    <Pagination.Item key={p} active={p === page} onClick={() => onPageChange(p)}>
                        {p}
                    </Pagination.Item>
                ))}
                {end < totalPages && <Pagination.Ellipsis disabled />}
                <Pagination.Next onClick={() => onPageChange(page + 1)} disabled={page >= totalPages} />
                <Pagination.Last onClick={() => onPageChange(totalPages)} disabled={page >= totalPages} />
            </Pagination>
        </div>
    );
};

export default DataTablePagination;
